/*
 * @Author: zrl1012 1027721592@qq.com
 * @Date: 2021-12-08 23:16:45
 * @LastEditors: zrl1012 1027721592@qq.com
 * @LastEditTime: 2022-08-25 16:14:46
 * @FilePath: \fp_pos_home\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import { Message } from 'ant-design-vue'
import VueLazyLoad from 'vue-lazyload'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import "swiper/dist/css/swiper.css";
import 'animate.css/animate.min.css';
import 'lib-flexible'
Vue.use(ElementUI);
import {
    Timeline,
    Input,
    Icon,
    Upload

} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import { WOW } from 'wowjs'

Vue.use(VueAwesomeSwiper)
Vue.use(Timeline)
Vue.use(Input)
Vue.use(Icon)
Vue.use(Upload)

Vue.use(VueLazyLoad, {
    preLoad: 1,
    error: require('@/assets/error.png'),
    loading: require('@/assets/error.png'),
    attempt: 2,
})

router.afterEach(() => {
    document.documentElement.scrollTop = 0;
})

Vue.prototype.$message = Message;

Vue.prototype.$wow = new WOW({
    boxClass: 'wow', // default
    animateClass: 'animated', // default
    offset: 200, // default
    mobile: true, // default
    live: false,

    callback: function(box) {
        console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
    }
})
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js